import { useTranslation } from 'react-i18next';



const ErrorApp = () => {
	const { t } = useTranslation('global');

	return (
		<div className="lfmt-error error-app">
			
			<h1>{t('errorHeader')}</h1>

			<p>{t('errorMessage')}</p>

		</div>
	);
};

export default ErrorApp;